//import hook react
import React from 'react';

//import hook useHitory from react router dom
import { useHistory } from 'react-router';

//import axios
import axios from 'axios';

const NavBar = (props) => {
    //define user
    const user = props.user;

    //define history
    const history = useHistory();

    //token
    const token = localStorage.getItem(process.env.REACT_APP_TOKEN_NAME);

    //function logout
    const logoutHandler = async () => {
        localStorage.removeItem(process.env.REACT_APP_TOKEN_NAME);
        localStorage.removeItem(process.env.REACT_APP_USER_STORAGE);
        window.location.replace(process.env.REACT_APP_API_URL + '/logout_sso?redirect_uri=' + process.env.REACT_APP_WEB_URL);
    };

    return (
        <div>
            <a href="/dashboard" className="btn btn-md ">Dashboard</a>|&nbsp;
            <a href="/user-management" className="btn btn-md ">User Management</a>
            <button onClick={logoutHandler} className="btn btn-md btn-danger">LOGOUT</button>
        </div>
    )

}

export default NavBar;